

import { unitedStatesData } from './unitedStatesData';
import { brazilData } from './brazil';
import { mexicoData } from './mexico';
import { argentinaData } from './argentina';
import { colombiaData } from './colombia';
import { peruData } from './peru';
import { northAmericaCountries } from './northAmericaCountries';
import { centralAmericaCountries } from './centralAmericaCountries';
import { otherSouthAmericaCountries } from './otherSouthAmericaCountries';
import { northAmericaExpansion } from './northAmericaExpansion';
import { southAmericaExpansion2 } from './southAmericaExpansion2';
import { southAmericaExpansion3 } from './southAmericaExpansion3';
import { americaExpansion6 } from './americaExpansion6';
import { WorldCountry } from '../types';

export const americaCountries: WorldCountry[] = [
  unitedStatesData,
  brazilData,
  mexicoData,
  argentinaData,
  colombiaData,
  peruData,
  ...northAmericaCountries,
  ...centralAmericaCountries,
  ...otherSouthAmericaCountries,
  ...northAmericaExpansion, // Incluye canadaExpanded
  ...southAmericaExpansion2, // Incluye Chile y Venezuela expandidos
  ...southAmericaExpansion3, // Incluye Argentina expandida
  ...americaExpansion6 // Incluye Jamaica, Trinidad y Tobago, Barbados y Bahamas expandidos - Fase 12
];

